export default __webpack_public_path__ + "assets/images/b527cdea43a312dcc59d6e8e9c3bad43.png";